import { toast } from "sonner";
import { useFinancesWizardNavigation } from "web_myplann/Finances/Hooks/useFinancesWizardNavigation";
import { IncomeBackTo } from "web_myplann/Finances/Types/FinancesNavigationState";
import { useOnlineStatus } from "web_myplann/Infrastructure/Hooks/useOnlineStatus";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const useFinancesEdit = () => {
	const { t } = useResource();
	const isOnline = useOnlineStatus();
	const { navigationState, goToStep } = useFinancesWizardNavigation();

	const onEdit = () => {
		if (!isOnline) {
			toast.error(t(Resources.Finances.Offline.editError));
			return;
		}
		goToStep(Routing.Finances.Income.path(), {
			from: navigationState.from,
			incomeBackTo: IncomeBackTo.Intro,
		});
	};

	return { onEdit };
};
